"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVerifyPhoneByCodeFromSms = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var useVerifyPhoneByCodeFromSms = function (_a) {
    var _b = _a.successAction, successAction = _b === void 0 ? function () { } : _b, _c = _a.errorAction, errorAction = _c === void 0 ? function () { } : _c;
    var _d = (0, useMutation_1.useMutation)({
        successAction: function () {
            successAction === null || successAction === void 0 ? void 0 : successAction();
        },
        errorAction: function () {
            errorAction === null || errorAction === void 0 ? void 0 : errorAction();
        },
        keysUpdate: [keys_1.USER, keys_1.MY_BONUSES, keys_1.MY_FREESPINS],
        path: keys_1.VERIFY_PHONE_BY_CODE,
    }), mutate = _d.mutate, isSubmitting = _d.isSubmitting, error = _d.error;
    return (0, react_1.useMemo)(function () { return ({
        verifyPhoneByCodeFromSms: mutate,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [mutate, isSubmitting, error]);
};
exports.useVerifyPhoneByCodeFromSms = useVerifyPhoneByCodeFromSms;
